export const isShowSectionForAnnuityPayout = (policies) => {
  var isAnnuityPayOutShow = false;

  if (policies.length > 0) {
    const policyWithPayOutFlag = policies?.find(
      (policy) => policy?.annuityPayoutIndicatorFlag === "Y"
    );
    if (!policyWithPayOutFlag && policies.length === 0)
      isAnnuityPayOutShow = true;

    if (
      policies.length > 1 &&
      policies?.find((policy) => policy?.annuityPayoutIndicatorFlag === "N")
    ) {
      isAnnuityPayOutShow = true;
    }
  }
  return isAnnuityPayOutShow;
};
